<template>
  <div
    class="flex min-h-[64px] w-full items-center gap-2.5 border-b border-[#efefef] px-2.5 py-2.5"
  >
    <Skeleton class="size-9 shrink-0 rounded-md" />
    <div class="min-w-0 flex-1">
      <Skeleton class="mb-2 h-[13px] w-[120px]" />
      <Skeleton class="h-[12px] w-[180px]" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Skeleton } from '@dacr/library'
</script>
